import BaseService from './base-service';

export default class GeofenceService extends BaseService {
    constructor() {
        super('geofences');
    }
}
